module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2_4.9df72c08.png";